import keys from "locale/keys";
import * as React from "react";
import { useTranslation } from "react-i18next";

import Step1Icon from "../../../assets/icons/steps-01.svg";
import Step2Icon from "../../../assets/icons/steps-02.svg";
import Step3Icon from "../../../assets/icons/steps-03.svg";
import Step4Icon from "../../../assets/icons/steps-04.svg";
import {
  HowItWorksHeader,
  HowItWorksList,
  HowItWorksSection,
  HowItWorksSubtitle,
  HowItWorksTitle,
  StepDescription,
  StepIconCircle,
  StepRow,
  StepTextBlock,
  StepTitle,
  StepVisual,
  StepVisualBlob,
} from "./styled.components";

const STEPS = [
  {
    icon: Step1Icon,
    titleKey: keys.how_it_works_step1_title,
    descriptionKey: keys.how_it_works_step1_description,
  },
  {
    icon: Step2Icon,
    titleKey: keys.how_it_works_step2_title,
    descriptionKey: keys.how_it_works_step2_description,
  },
  {
    icon: Step3Icon,
    titleKey: keys.how_it_works_step3_title,
    descriptionKey: keys.how_it_works_step3_description,
  },
  {
    icon: Step4Icon,
    titleKey: keys.how_it_works_step4_title,
    descriptionKey: keys.how_it_works_step4_description,
  },
];

const HowItWorks = () => {
  const { t } = useTranslation();

  return (
    <HowItWorksSection>
      <HowItWorksHeader>
        <HowItWorksTitle>{t(keys.how_it_works_title)}</HowItWorksTitle>
        <HowItWorksSubtitle>{t(keys.how_it_works_subtitle)}</HowItWorksSubtitle>
      </HowItWorksHeader>
      <HowItWorksList>
        {STEPS.map((step, index) => (
          <StepRow key={step.titleKey} reverse={index % 2 === 1}>
            <StepTextBlock>
              <StepTitle>{t(step.titleKey)}</StepTitle>
              <StepDescription>{t(step.descriptionKey)}</StepDescription>
            </StepTextBlock>
            <StepVisual>
              <StepVisualBlob />
              <StepIconCircle>
                <img
                  src={step.icon}
                  alt={t(step.titleKey)}
                  width={32}
                  height={32}
                />
              </StepIconCircle>
            </StepVisual>
          </StepRow>
        ))}
      </HowItWorksList>
    </HowItWorksSection>
  );
};

export default HowItWorks;
